import React , {Component} from 'react'
import classnames from 'classnames'
import {  NavItem ,NavLink} from 'reactstrap'
import { Link, NavLink as RRNavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { Collapse } from 'reactstrap'
import MediaQuerySelectors from "redux-modules/media-query/MediaQuerySelectors"
import { NavHashLink as NavLinkHash } from 'react-router-hash-link'
import scrollIntoView from 'scroll-into-view'

const links=[
    {
        to: "/",
        label:"Home",
        img: "img/home-black.png",
        imgWhite: "img/home-white.png",
        imgGradient: "img/home-gradient.png"
    },
    {
        to: "/about",
        label: "About",
        img: "img/about-black.png",
        imgWhite: "img/about-white.png",
        imgGradient: "img/about-gradient.png"
    },
    {
        to: "/careers",
        label:"Careers",
        img: "img/career-black.png",
        imgWhite: "img/career-white.png",
        imgGradient: "img/career-gradient.png"
    },
    // {
    //     to: "/#brand",
    //     label:"Customised",
    //     img: "img/customised-black.png",
    //     imgWhite: "img/customised-white.png",
    //     imgGradient: "img/customised-gradient.png"
    // },
    {
        to: "/enquiry",
        label:"See Demo",
        img: "img/demo-black.png",
        imgWhite: "img/demo-white.png",
        imgGradient: "img/demo-gradient.png"
    }
]



class Navbar  extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            navbarFix: false ,
            navbarAppear: false,
            menuIsOpen:false,
            hoverLink: -1,
            activeLink: -1
        };
    }

    componentDidMount() {
        this.prev = window.scrollY;
        if(this.props.homePage) {
            window.addEventListener('scroll', this.handleScroll);
        }

        //var rect= this.container.getBoundingClientRect();
        //console.log(rect.top, rect.right, rect.bottom, rect.left);
    }

    handleScroll = (e) => {
        //var rect= this.container.getBoundingClientRect();
        //console.log(rect.top, rect.right, rect.bottom, rect.left);
        //console.log("scoll",window.pageYOffset,rect.top)
        var currYOffSet = window.pageYOffset;
        var yOffset = 160;
        var yOffsetAppear = 220;
        const tar = e.currentTarget;
        if(  currYOffSet > yOffset &&  currYOffSet <= yOffsetAppear) {
          console.log("fixed hidden",currYOffSet)
            ///this.setState({ navbarFix: true, navbarAppear: false  });
            if(this.prev > tar.scrollY){
                console.log("scrolling up");
                this.setState({ navbarFix: true, navbarAppear: false, navbarLeave: true  });
            } else {
                this.setState({ navbarFix: true, navbarAppear:false, navbarLeave: false  });
            }
        }
        if(  currYOffSet > yOffsetAppear ) {
            // console.log("fixed appear",currYOffSet)
            this.setState({ navbarFix: true ,navbarAppear: true });
        }
        else if(currYOffSet <= yOffset    ){
            // console.log("relative",currYOffSet)
            this.setState({ navbarFix: false ,navbarAppear: false,navbarLeave: false  });
        }
        this.prev = tar.scrollY;

    };

    componentWillUnmount() {
        if(this.props.homePage) {
            window.removeEventListener('scroll', this.handleScroll);
        }

    }

    toggleNavbar=() =>{
        this.setState({menuIsOpen: !this.state.menuIsOpen})
    }

    closeNavbar=() =>{
        if(this.state.menuIsOpen) {
            this.toggleNavbar()
        }
    }

    hover = (index) => {
        this.setState({hoverLink: index})
    }

    unhover = () => {
        this.setState({hoverLink: -1})
    }

    active = (link, index) => {
        // conditions to prevent infinite loop
        if (this.props.location.pathname + this.props.location.hash === link.to && this.state.activeLink !== index) {
            this.setState({activeLink: index})
        }
        return this.props.location.pathname + this.props.location.hash === link.to
    }

    render () {
        let NavbarHeight = 100
        var isFixed =!this.props.homePage || this.props.isMobile ||this.state.navbarFix
        return (
            <div style={{}}>
                <nav ref={(n) => this.navbar = n} id="header" className={!this.props.homePage || this.props.isMobile? "navbar navbar-light navbar-expand-lg fixed-top":classnames("navbar navbar-light navbar-expand-lg",{"fixed-top fixed-hidden":this.state.navbarFix, "navbar-static-top":!this.state.navbarFix, "leave":this.state.navbarLeave, "appear":this.state.navbarAppear})}>
                    <div id="header-container" className="container-fluid navbar--container">
                            <Link className={classnames({'navbar-brand': !isFixed, 'navbar-brand--fixed': isFixed})} to="/">
                                <img src="img/logo-new-white.png" width="80%" alt=""/>
                            </Link>
                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                                    onClick={this.toggleNavbar}>
                                <span className="navbar-toggler-icon"/>
                            </button>
                      {/*  <div className="collapse navbar-collapse" id="navbarSupportedContent">*/}
                            <Collapse isOpen={this.state.menuIsOpen} navbar className={classnames({'d-flex justify-content-end': !this.props.isMobile})}>
                                <ul className="navbar-nav">
                                    {links.map((link, index) => <NavItem key={link.to} style={{position: 'relative'}}>
                                        {this.state.activeLink === index && this.props.location.pathname + this.props.location.hash === link.to && this.state.hoverLink !== index ?
                                            <div className='nav--link--active-line' /> : null
                                        }
                                        <NavLink onMouseEnter={() => this.hover(index)} onMouseLeave={this.unhover}
                                        className={classnames('text-center', {'nav--link': !isFixed, 'nav--link--fixed': isFixed})} activeClassName="active" 
                                        isActive={()=> this.active(link, index)} onClick={this.closeNavbar} tag={NavLinkHash} exact to={link.to}
                                            scroll={el =>  scrollIntoView(el,{ time:700, align:{
                                                top:0,
                                                left: 0
                                        }})}>
                                            <div className='d-flex align-items-end mb-2' style={{height: '25px', width: '25px', margin: 'auto'}}>
                                                <img style={{width: '25px'}} src={this.state.hoverLink === index ? link.imgGradient : (this.state.activeLink === index && this.props.location.pathname + this.props.location.hash === link.to ? link.imgWhite : link.img)}/>
                                            </div>
                                            <div>{link.label}</div>
                                        </NavLink>
                                    </NavItem>)}
                                </ul>
                            </Collapse>
                       {/* </div>*/}
                    </div>
                </nav>
            </div>
        )
    }
}
const mapDispatchToProps = {
}

const mapStateToProps = (state, props) => ({
    isMobile: MediaQuerySelectors.isMobileSelector(state, props),
    location:state.router.location
})


export default connect(mapStateToProps, mapDispatchToProps )(Navbar)





// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.js